<template>
  <div class="flex justify-between items-center">
    <h2 class="text-size-h2 font-semibold">{{ title }}</h2>

    <div class="navigation flex items-center gap-3 max-md:hidden">
      <UButton
        :variant="!isStart ? 'solid' : 'outline'"
        icon="i-local-chevron-left"
        :class="{
          'text-white': !isStart,
        }"
        @click="emit('prev')"
      />

      <div class="font-lato! text-size-md text-neutral-default">
        {{ Math.floor(current || 0) }} / {{ total }}
      </div>

      <UButton
        :variant="!isEnd ? 'solid' : 'outline'"
        icon="i-local-chevron-right"
        @click="emit('next')"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
defineOptions({
  name: 'SPGallerySectionHeader',
})

withDefaults(
  defineProps<{
    title?: string
    current: number
    total: number
    perView: number
    isStart?: boolean
    isEnd?: boolean
  }>(),
  {
    title: 'Галерея',
  },
)

const emit = defineEmits<{
  prev: []
  next: []
}>()
</script>

<style lang="scss" scoped></style>
